"use client";
import React, { Fragment } from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import SecurityServicesTabs from "@/components/pageTabs/securityServicesTabs";
import AdvantagesComp from "./components/advantages";
import WhyOneMindComponent from "./components/whyOneMind";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComp from "./components/features";
import EdrMdrSecStack from "./components/cyberSecStack";
import CollabComp from "./components/sophosCollab";

const EdrMdrXdrPage = () => {
  return (
    <Fragment>
      <Box>
        <Hero />
        <PageLayout>
          <SecurityServicesTabs />
          <Intro />
          <AdvantagesComp />
        </PageLayout>
      </Box>
      <Box>
        <CollabComp />
        <FeaturesComp />
      </Box>
      <PageLayout showContactForm>
        <WhyOneMindComponent />
        <EdrMdrSecStack />
        <Faqs />
      </PageLayout>
    </Fragment>
  );
};

export default EdrMdrXdrPage;
